<template>
   <div class="guest-selector">
      <div class="guest-selector-inner">
         <div class="guest-selector-section guest-room-section" v-for="(roomItem, roomIndex) in rooms" :key="roomIndex">
            <div class="guest-room-section-inner">
               <div class="guest-room-title">
                  <span>
                     <strong>{{ roomIndex + 1 }}. {{ $t("hotelSearchGuest_lblRoomCount") }}</strong>
                  </span>
                  <button id="btn_removeRoom" @click="handlerRemoveRoom(roomIndex)" v-if="roomIndex > 0">
                     {{ $t("hotelSearchGuest_btnRemoveRoom") }}
                  </button>
               </div>
               <div class="guest-info">
                  <div class="guest-info-item">
                     <div class="guest-info-label">
                        <span>{{ $t("hotelSearchGuest_lblAdult") }}</span>
                     </div>
                     <div class="guest-info-counter">
                        <button class="decrement" @click="handlerDecrementGuestCount('adults', roomIndex)" :disabled="roomItem.adults == 1">-</button>
                        <span class="count">{{ roomItem.adults }}</span>
                        <button class="increment" @click="handlerIncrementGuestCount('adults', roomIndex)">+</button>
                     </div>
                  </div>
                  <div class="guest-info-item">
                     <div class="guest-info-label">
                        <span>{{ $t("hotelSearchGuest_lblChild") }}</span>
                     </div>
                     <div class="guest-info-counter">
                        <button class="decrement" @click="handlerDecrementGuestCount('children', roomIndex)" :disabled="roomItem.children == 0">-</button>
                        <span class="count">{{ roomItem.children }}</span>
                        <button class="increment" @click="handlerIncrementGuestCount('children', roomIndex)">+</button>
                     </div>
                  </div>
                  <div class="guest-info-item" v-for="childIndex in roomItem.children" :key="`room-${roomIndex}-child-${childIndex}`">
                     <div class="guest-info-label">
                        <span>{{ childIndex }}. {{ $t("hotelSearchGuest_lblChild") }}</span>
                     </div>
                     <div class="guest-info-age">
                        <select
                           :name="`select_childrenAge-room${roomIndex}-child${childIndex}`"
                           :id="`select_childrenAge-room${roomIndex}-child${childIndex}`"
                           v-model="roomItem.childrenAges[childIndex - 1]">
                           <option disabled selected value="undefined">{{ $t("common_chooseChildAge") }}</option>
                           <option v-for="ageIndex in 19" :key="ageIndex" :value="ageIndex - 1">{{ ageIndex - 1 }}</option>
                        </select>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="guest-selector-section room-cta-section">
            <UIButton className="default" icon="add-leg" rounded="true" @click.native="handlerAddRoom" v-if="this.rooms.length < 5" />
         </div>
      </div>
   </div>
</template>

<script>
import UIButton from "@/components/unitary/Button.vue";

export default {
   name: "GuestSelector",
   components: {
      UIButton,
   },
   props: {
      value: {
         type: Array,
         default: () => [
            {
               adults: 2,
               children: 0,
               childrenAges: [],
            },
         ],
      },
   },
   data() {
      return {
         rooms: JSON.parse(JSON.stringify(this.value)),
      };
   },
   computed: {
      guestTotalCount() {
         let adultCount = 0;
         let childCount = 0;

         for (let i = 0; i < this.rooms.length; i++) {
            adultCount += this.rooms[i].adults;
            childCount += this.rooms[i].children;
         }

         return {
            adult: adultCount,
            child: childCount,
         };
      },
   },
   methods: {
      handlerRemoveRoom(index) {
         event.stopPropagation();
         if (this.rooms.length > 1) {
            this.rooms.splice(index, 1);
         }
      },
      handlerAddRoom() {
         event.stopPropagation();
         if (this.rooms.length < 5) {
            this.rooms.push({
               adults: 2,
               children: 0,
               childrenAges: [],
            });
         }
      },
      handlerDecrementGuestCount(guestType, index) {
         event.stopPropagation();
         if (guestType === "adults") {
            if (this.rooms[index].adults > 1) {
               this.rooms[index].adults -= 1;
            }
         } else if (guestType === "children") {
            if (this.rooms[index].children > 0) {
               this.rooms[index].children -= 1;

               if (this.rooms[index].children == 0) {
                  this.rooms[index].childrenAges = [];
               } else if (this.rooms[index].children < this.rooms[index].childrenAges.length) {
                  this.rooms[index].childrenAges.splice(-1, 1);
               }
            }
         }
      },
      handlerIncrementGuestCount(guestType, index) {
         event.stopPropagation();
         if (guestType === "adults") {
            if (this.rooms[index].adults < 10) {
               this.rooms[index].adults += 1;
            }
         } else if (guestType === "children") {
            if (this.rooms[index].children < 5) {
               this.rooms[index].children += 1;
            }
         }
      },
   },
   watch: {
      value: {
         handler: function (newValue) {
            if (newValue && JSON.stringify(newValue) !== JSON.stringify(this.rooms)) {
               this.rooms = JSON.parse(JSON.stringify(newValue));
            }
         },
         deep: true,
      },
      rooms: {
         handler: function (newValue) {
            // v-model için input event'i emit et
            this.$emit("input", JSON.parse(JSON.stringify(newValue)));
            // Geriye dönük uyumluluk için eski event'ler
            this.$emit("update-to-rooms", newValue);
            this.$emit("update-guest-count", this.guestTotalCount);
         },
         deep: true,
      },
   },
   created() {
      // İlk yüklemede de emit et
      this.$emit("update-to-rooms", this.rooms);
      this.$emit("update-guest-count", this.guestTotalCount);
   },
};
</script>

<style lang="scss" scoped>
.guest-selector {
   width: 100%;
   background-color: var(--container-bg);
   color: var(--gray-700);

   .guest-selector-inner {
      padding: 20px 16px;
      border-radius: 0.5rem;
      box-shadow: var(--gts-box-shadow);

      .guest-selector-section {
         margin-bottom: 24px;

         &:last-child {
            margin-bottom: 0;
         }

         .guest-room-section-inner {
            .guest-room-title {
               display: flex;
               align-items: center;
               justify-content: space-between;
               width: 100%;
               margin-bottom: 16px;
               color: var(--txt-color);

               & > button {
                  background: none;
                  border: none;
                  color: var(--blue-500);
               }
               span,
               strong {
                  color: inherit;
               }
            }

            .guest-info {
               .guest-info-item {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 16px;

                  &:last-child {
                     margin-bottom: 0;
                  }

                  .guest-info-label {
                  }
                  .guest-info-counter {
                     display: flex;
                     align-items: center;
                     border: 1px solid var(--gray-300);
                     border-radius: 8px;

                     .decrement,
                     .increment {
                        display: inline-block;
                        padding: 4px 8px;
                        background: none;
                        border: none;
                        color: var(--gray-700);
                     }

                     .decrement {
                        border-right: 1px solid var(--gray-300);
                     }
                     .count {
                        width: 32px;
                        max-width: 32px;
                        text-align: center;
                     }
                     .increment {
                        border-left: 1px solid var(--gray-300);
                     }
                  }

                  .guest-info-age {
                     width: 45%;
                     select {
                        width: 100%;
                        padding: 4px 8px;
                        border: 2px solid var(--gts-input-border);
                        border-radius: 8px;
                     }
                  }
               }
            }
         }

         &.guest-room-section {
            padding-bottom: 20px;
            border-bottom: 1px solid var(--gray-300);
         }
         &.room-cta-section {
            display: flex;
            justify-content: center;
            align-items: center;

            & > button {
               background: none;
            }
         }
      }
   }
}
</style>
